import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import axios from "axios";
import { setBreadcrumbItems } from "../../store/actions";
import TechnologyCards from "./ZeroTechnologiesCards";
import { MutatingDots } from "react-loader-spinner";
import { connect } from "react-redux";

const ZeroCourseCards = (props) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [originalCourses, setOriginalCourses] = useState([]);
  const [courseRegistrations, setCourseRegistrations] = useState([]);
  const [visibleTechnologyCards, setVisibleTechnologyCards] = useState(false);
  const [technologies, setTechnologies] = useState([]);
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [courseProgramsLoader, setCourseProgramsLoader] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Zero Payments", link: "#" },
    { title: "Zero Course Payments", link: "#" },
  ];


  useEffect(() => {
    fetchCoursePrograms();
    props.setBreadcrumbItems("Zero Course Payments", breadcrumbItems);

  }, []);

  useEffect(() => {
    console.log(searchQuery)
    if (searchQuery.trim() === "") {
      setCourseRegistrations(originalCourses);
    }
    else {
      console.log("hello")
      const filteredCourses = originalCourses.filter((course) =>
        course.course_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        course.passout_year.toString().includes(searchQuery)
      );
      setCourseRegistrations(filteredCourses);
    }
  }, [searchQuery,originalCourses])

  const fetchCoursePrograms = async () => {
    try {
      const response = await axios.get(`${backendUrl}get-course-programs`);
      if (response.status === 200) {
        setOriginalCourses(response.data.courseRegistrations); // store original
        setCourseRegistrations(response.data.courseRegistrations);
        setCourseProgramsLoader(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFetchTechnologies = async (id, passout_year, course_name) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${backendUrl}get-technologies-by-course-registration-zero-course-payments/${id}?passout_year=${passout_year}`
      );
      console.log(response.data);
      if (response.status === 200) {
        setTechnologies(response.data.technologies);
        setSelectedCourseId(id);
        setSelectedCourseName(course_name);
        setVisibleTechnologyCards(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Color palette for variety
  const cardColors = [
    "linear-gradient(135deg, #6d85ff 0%, #9965ff 100%)", // deep lavender-blue
    "linear-gradient(135deg, #4fd6a2 0%, #66adff 100%)", // vivid aqua-blue
    "linear-gradient(135deg, #ffa866 0%, #ff6f7a 100%)", // warm peach-pink
    "linear-gradient(135deg, #6fdede 0%, #7faeff 100%)", // bright teal-blue
    "linear-gradient(135deg, #ff8f47 0%, #ff5f97 100%)", // vibrant coral-pink
  ];



  return (
    <React.Fragment>
      <h1 className="fw-bold text-primary d-flex justify-content-center lh-lg">
        Zero Course Payments
      </h1>
      {
        courseProgramsLoader && courseRegistrations.length === 0 ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "300px" }}
          >
            <MutatingDots
              visible
              height="100"
              width="100"
              color="#2B3A4A"
              secondaryColor="#2B3A4A"
              radius="12.5"
              ariaLabel="mutating-dots-loading"
            />
          </div>
        ) : (
          <>
            <Row className="mb-3 d-flex justify-content-end">
              <Col>
                <h4 className="fw-bold text-primary">
                  Select Course Program
                </h4>
              </Col>
              <Col xs={3}>
                <input
                  type="text"
                  placeholder="Search Course name or passout year"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="form-control"
                />
              </Col>
            </Row>
            <Row className="g-4">

              {courseRegistrations
                .sort((a, b) => a.order - b.order)
                ?.map((ele, key) => (
                  <Col
                    xl={3}
                    sm={6}
                    key={key}
                    onClick={() =>
                      handleFetchTechnologies(
                        ele.course_id,
                        ele.passout_year,
                        ele.course_name
                        // ele.program_names[0],
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <Card
                      className="course-card"
                      style={{
                        background: cardColors[key % cardColors.length],
                        color: "white",
                        borderRadius: "10px",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "translateY(-6px)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      <CardBody
                        className="d-flex flex-column justify-content-between"
                      // style={{ minHeight: "180px" }}
                      >
                        <div>
                          <h5 className="text-uppercase fw-bold mb-2">
                            {/* {ele.program_names[0]} */}
                            {ele.course_name}
                          </h5>
                          <p className="text-white-50 mb-1">
                            Passout Year: {ele.passout_year}
                          </p>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
            </Row>
          </>
        )
      }

      {visibleTechnologyCards ? (
        <div className="mt-4">
          <TechnologyCards
            course_id={selectedCourseId}
            technologies={technologies}
            course_name={selectedCourseName}
          />
        </div>
      ) : (
        loading && (
          <div className="d-flex justify-content-center align-items-center mt-4">
            <MutatingDots
              height="100"
              width="100"
              color="#2B3A4A"
              secondaryColor="#2B3A4A"
              radius='12.5'
              ariaLabel="mutating-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        )
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(ZeroCourseCards);


